// Auto-generated from ValidationConstants.cs
// Do not edit this file manually

export const ValidationConstants = {
    DataTypeLimits: {
        MinBigInt: -9223372036854775808,
        MaxBigInt: 9223372036854775807,
        MinInt: -2147483648,
        MaxInt: 2147483647,
        MaxDecimal17_2: 999999999999999.99,
        MaxStringLength255: 255,
        MaxStringLength100: 100,
        MaxStringLength55: 55,
        MaxStringLength50: 50,
        MaxStringLength36: 36,
        MaxStringLength25: 25
    },
    VesselLimits: {
        MinImo: 1000000,
        MaxImo: 9999999,
        MinVesselLength: 0,
        MaxVesselLength: 999999,
        MinVesselWidth: 0,
        MaxVesselWidth: 9999,
        MinGrossTonnage: 0,
        MaxGrossTonnage: 999999,
        MinDaysInPort: 0,
        MaxDaysInPort: 9999
    },
    FinancialLimits: {
        MinPrice: 0.0,
        MaxPrice: 9999999.99,
        MinPriceInvoiceItem: 0.0,
        MaxPriceInvoiceItem: 9999999.9999,
        MinQuantity: 0,
        MaxQuantity: 999999999.999,
        QuantityFormat: 'n3',
        QuantityDecimals: 3,
        MinPercentage: 0.0,
        MaxPercentage: 100.0,
        PercentFormat: '#.## \\%',
        PercentDecimals: 2,
        MinPaymentDueDays: 0,
        MaxPaymentDueDays: 9999,
        MinPaymentDueDay: 1,
        MaxPaymentDueDay: 31,
        PaymentDueDayFormat: '#',
        PaymentDueDayDecimals: 0
    },
    CargoLimits: {
        MinContainerQuantity: 0,
        MaxContainerQuantity: 9999,
        MinCargoQuantity: 0,
        MaxCargoQuantity: 9999999.999,
        MinCargoVolume: 0,
        MaxCargoVolume: 9999999.999
    },
    PersonLimits: {
        MinPersonCount: 0,
        MaxPersonCount: 99999
    },
    AreaLimits: {
        MinArea: 0,
        MaxArea: 999999.99,
        AreaFormat: 'n2',
        AreaDecimals: 2
    },
    PowerConsumptionLimits: {
        MinConsumption: 0,
        MaxConsumption: 9999999.999,
        ConsumptionFormat: '#,##0.##',
        ConsumptionDecimals: 2,
        ConsumptionFormatKwh: '#,##0.## kWh',
        MinMeterReading: 0,
        MaxMeterReading: 99999999.999,
        MeterReadingDecimals: 2,
        MeterReadingFormatKwh: '#,##0.## kWh',
        MeterReadingFormatM3: '#,##0.## m3'
    }
};

// Type definitions for better IDE support
export type ValidationConstants = {
    DataTypeLimits: {
        readonly MinBigInt: number;
        readonly MaxBigInt: number;
        readonly MinInt: number;
        readonly MaxInt: number;
        readonly MaxDecimal17_2: number;
        readonly MaxStringLength255: number;
        readonly MaxStringLength100: number;
        readonly MaxStringLength55: number;
        readonly MaxStringLength50: number;
        readonly MaxStringLength36: number;
        readonly MaxStringLength25: number;
    };
    VesselLimits: {
        readonly MinImo: number;
        readonly MaxImo: number;
        readonly MinVesselLength: number;
        readonly MaxVesselLength: number;
        readonly MinVesselWidth: number;
        readonly MaxVesselWidth: number;
        readonly MinGrossTonnage: number;
        readonly MaxGrossTonnage: number;
        readonly MinDaysInPort: number;
        readonly MaxDaysInPort: number;
    };
    FinancialLimits: {
        readonly MinPrice: number;
        readonly MaxPrice: number;
        readonly MinPriceInvoiceItem: number;
        readonly MaxPriceInvoiceItem: number;
        readonly MinQuantity: number;
        readonly MaxQuantity: number;
        readonly QuantityFormat: string;
        readonly QuantityDecimals: number;
        readonly MinPercentage: number;
        readonly MaxPercentage: number;
        readonly PercentFormat: string;
        readonly PercentDecimals: number;
        readonly MinPaymentDueDays: number;
        readonly MaxPaymentDueDays: number;
        readonly MinPaymentDueDay: number;
        readonly MaxPaymentDueDay: number;
        readonly PaymentDueDayFormat: string;
        readonly PaymentDueDayDecimals: number;
    };
    CargoLimits: {
        readonly MinContainerQuantity: number;
        readonly MaxContainerQuantity: number;
        readonly MinCargoQuantity: number;
        readonly MaxCargoQuantity: number;
        readonly MinCargoVolume: number;
        readonly MaxCargoVolume: number;
    };
    PersonLimits: {
        readonly MinPersonCount: number;
        readonly MaxPersonCount: number;
    };
    AreaLimits: {
        readonly MinArea: number;
        readonly MaxArea: number;
        readonly AreaFormat: string;
        readonly AreaDecimals: number;
    };
    PowerConsumptionLimits: {
        readonly MinConsumption: number;
        readonly MaxConsumption: number;
        readonly ConsumptionFormat: string;
        readonly ConsumptionDecimals: number;
        readonly ConsumptionFormatKwh: string;
        readonly MinMeterReading: number;
        readonly MaxMeterReading: number;
        readonly MeterReadingDecimals: number;
        readonly MeterReadingFormatKwh: string;
        readonly MeterReadingFormatM3: string;
    };
};
